module.exports = __webpack_public_path__ + "static/Kontakt-wynajem-ksero-piotrkow-b86c8553339216a9c4bddb595809166d.svg";